export default 
    {
  "Africa/Abidjan": "+00:00",
  "Africa/Accra": "+00:00",
  "Africa/Addis_Ababa": "+03:00",
  "Africa/Algiers": "+01:00",
  "Africa/Cairo": "+02:00",
  "Africa/Casablanca": "+01:00",
  "Africa/Johannesburg": "+02:00",
  "Africa/Lagos": "+01:00",
  "Africa/Nairobi": "+03:00",

  "America/Anchorage": "-09:00",
  "America/Argentina/Buenos_Aires": "-03:00",
  "America/Bogota": "-05:00",
  "America/Chicago": "-06:00",
  "America/Denver": "-07:00",
  "America/Los_Angeles": "-08:00",
  "America/Mexico_City": "-06:00",
  "America/New_York": "-05:00",
  "America/Phoenix": "-07:00",
  "America/Santiago": "-04:00",
  "America/Sao_Paulo": "-03:00",
  "America/Toronto": "-05:00",

  "Asia/Amman": "+02:00",
  "Asia/Baghdad": "+03:00",
  "Asia/Bangkok": "+07:00",
  "Asia/Beirut": "+02:00",
  "Asia/Dubai": "+04:00",
  "Asia/Hong_Kong": "+08:00",
  "Asia/Jakarta": "+07:00",
  "Asia/Jerusalem": "+02:00",
  "Asia/Karachi": "+05:00",
  "Asia/Kathmandu": "+05:45",
  "Asia/Kolkata": "+05:30",
  "Asia/Seoul": "+09:00",
  "Asia/Shanghai": "+08:00",
  "Asia/Singapore": "+08:00",
  "Asia/Tokyo": "+09:00",

  "Australia/Adelaide": "+09:30",
  "Australia/Brisbane": "+10:00",
  "Australia/Darwin": "+09:30",
  "Australia/Melbourne": "+10:00",
  "Australia/Perth": "+08:00",
  "Australia/Sydney": "+10:00",

  "Europe/Amsterdam": "+01:00",
  "Europe/Athens": "+02:00",
  "Europe/Berlin": "+01:00",
  "Europe/Brussels": "+01:00",
  "Europe/Bucharest": "+02:00",
  "Europe/Budapest": "+01:00",
  "Europe/Copenhagen": "+01:00",
  "Europe/Dublin": "+00:00",
  "Europe/Helsinki": "+02:00",
  "Europe/Lisbon": "+00:00",
  "Europe/London": "+00:00",
  "Europe/Luxembourg": "+01:00",
  "Europe/Madrid": "+01:00",
  "Europe/Oslo": "+01:00",
  "Europe/Paris": "+01:00",
  "Europe/Prague": "+01:00",
  "Europe/Rome": "+01:00",
  "Europe/Stockholm": "+01:00",
  "Europe/Vienna": "+01:00",
  "Europe/Warsaw": "+01:00",
  "Europe/Zurich": "+01:00",

  "Pacific/Auckland": "+12:00",
  "Pacific/Fiji": "+12:00",
  "Pacific/Honolulu": "-10:00",
  "Pacific/Port_Moresby": "+10:00",
  "Pacific/Tahiti": "-10:00"

}